
export const getRedirecturl = () =>{
  if(typeof window !== "undefined"){
    console.log(window.location.origin);
    return `${window.location.origin}`;
  }
}

export const oidcConfig = {
  authority: process.env.REACT_APP_AUTHORITY || "",
  client_id: process.env.REACT_APP_CLIENTID || "", 
  redirect_uri: getRedirecturl() as string + "/callback", 
  logout_redirect_uri: process.env.REACT_APP_LOGOUT_URL || "", 
  response_type: 'code', 
  scope: 'openid profile email',
  automaticSilentRenew: true, 
  filterProtocolClaims: true, 
  loadUserInfo: true, 
};
